<div class="form-group">
  <label class="{{labelCls}}">{{label}} <sub *ngIf="required"
                                            class="ml-1 text-danger font-size-sm font-weight-bold">*</sub></label>
  <ng-content></ng-content>
  <ng-content select="delv-form-error"></ng-content>
</div>

